import React, { useMemo } from "react";
import Moment from "moment";

import { Tooltippy } from "../../actions/Tippy";
import { Popover } from "../../actions/Tippy";

import { ReactComponent as PhoneIcon } from "../../build/images/teams/call.svg";
import { ReactComponent as InfoCircle } from "../../build/images/info-circle.svg";
import { ReactComponent as ActionIcon } from "../../build/images/more.svg";
import { ReactComponent as SMSICON } from "../../build/images/sms-new.svg";
import { ReactComponent as Call } from "../../build/images/teams/call.svg";
import { ReactComponent as Calendar } from "../../build/images/teams/calendar.svg";
import { ReactComponent as Attention } from "../../build/images/danger.svg";
import { ReactComponent as Timer } from "../../build/images/timer.svg";
import { ReactComponent as HappyRating } from "../../build/images/icons-rating/happy.svg";
import { ReactComponent as IndifRating } from "../../build/images/icons-rating/indifferent.svg";
import { ReactComponent as SadRating } from "../../build/images/icons-rating/sad.svg";
import { ReactComponent as NullRating } from "../../build/images/icons-rating/star-slash.svg";

import "./queue-item-v2.styles.css";
import { connection_platform } from "../../services/api";
import UserPhoto from "../UserPhoto/userphoto";
import { useSelector } from "react-redux";
import TimeCounterMinute from "../../containers/TimeCounterMinute";
import { getIconByChannel } from "../../utils/getIconByChannel";
var ipcurrent = "";
var gethostname = window.location.hostname;
var pathname = "";
var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  // if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

const QueueItemV2 = ({
  contactName,
  score,
  classScore,
  pathfile,
  dateTime,
  standbyId,
  phoneNumber,
  mediaId,
  isExpanded,
  contactId,
  cdrId,
  idAtendimento,
  unreadMessages,
  isAnswerDisabled = false,
  renderPopover = () => { },
  renderMoreOptions = () => { },
  onAnswer = () => { },
}) => {
  const difftime = useSelector((state) => state.ipcurrent.difftime);
  const antes = useMemo(() => {
    if (difftime < 0) {
      return Moment(dateTime, "DD/MM/YYYY HH:mm:ss").format(
        "YYYY/MM/DD HH:mm:ss"
      );
    }

    return Moment(dateTime, "DD/MM/YYYY HH:mm:ss").format(
      "YYYY/MM/DD HH:mm:ss"
    );
  }, [difftime, dateTime]);
  const agora = useMemo(() => {
    if (difftime < 0) {
      return Moment()
        .add(Math.round(difftime), "seconds")
        .format("YYYY/MM/DD HH:mm:ss");
    }

    return Moment()
      .subtract(Math.round(difftime), "seconds")
      .format("YYYY/MM/DD HH:mm:ss");
  }, [difftime]);
  const duracao = useMemo(() => {
    return Moment(agora).diff(antes, "seconds");
  }, [antes, agora]);
  const dias = useMemo(() => {
    return Moment(agora).diff(antes, "days");
  }, [antes, agora]);

  const renderAvaliation = (score, classScore) => {
    switch (classScore) {
      case "otimo":
        return (
          <Tooltippy content={score} placement="top">
            <div className="user-rating__tag happy">
              <HappyRating />
              Cliente satisfeito
            </div>
          </Tooltippy>
        );

      case "promotor":
        return (
          <Tooltippy content={score} placement="top">
            <div className="user-rating__tag happy">
              <HappyRating />
              Cliente satisfeito
            </div>
          </Tooltippy>
        );

      case "razoavel":
        return (
          <Tooltippy content={score} placement="top">
            <div className="user-rating__tag indifferent">
              <IndifRating />
              Cliente indiferente
            </div>
          </Tooltippy>
        );

      case "neutro":
        return (
          <Tooltippy content={score} placement="top">
            <div className="user-rating__tag indifferent">
              <IndifRating />
              Cliente indiferente
            </div>
          </Tooltippy>
        );

      case "ruim":
        return (
          <Tooltippy content={score} placement="top">
            <div className="user-rating__tag sad">
              <SadRating />
              Cliente insatisfeito
            </div>
          </Tooltippy>
        );

      case "detrator":
        return (
          <Tooltippy content={score} placement="top">
            <div className="user-rating__tag sad">
              <SadRating />
              Cliente insatisfeito
            </div>
          </Tooltippy>
        );

      default:
        return (
          <div className="user-rating__tag">
            <NullRating />
            Nenhuma avaliação
          </div>
        );
    }
  };
  return (
    <div className="queue-item-v2">
      <div className="queue-item-v2__header">
        <div className="queue-item-v2__header__contact-holder">
          <div className="queue-item-v2__header__contact-holder__icon">
            <UserPhoto
              size="large"
              link={
                pathfile
                  ? connection_platform.type_connect +
                  "://" +
                  ipcurrent +
                  pathfile
                  : null
              }
              letterIcon={contactName}
            />
            <div className="queue-item-v2__header__contact-holder__icon__media">
              {getIconByChannel(mediaId)}
            </div>
          </div>
          <div className="queue-item-v2__header__contact-holder__contact-container">
            <Tooltippy content={contactName} placement="top">
              <span className="queue-item-v2__header__contact-holder__contact-container__name">
                {contactName}
              </span>
            </Tooltippy>
            <div className="user-rating">
              {renderAvaliation(score, classScore)}
            </div>
          </div>
        </div>
        <div className="queue-item-v2__header__actions-conatiner">
          <div className="queue-item-v2__header__actions">
            <button
              className="queue-item-v2__header__actions__btn"
              disabled={isAnswerDisabled}
              style={isAnswerDisabled ? { opacity: 0.4, cursor: "not-allowed" } : {}}
              onClick={() => {
                if (isAnswerDisabled) return;
                onAnswer(
                  contactName,
                  score,
                  classScore,
                  pathfile,
                  dateTime,
                  standbyId,
                  phoneNumber,
                  mediaId,
                  isExpanded,
                  contactId,
                  cdrId,
                  idAtendimento,
                  unreadMessages
                );
              }}
            >
              <PhoneIcon />
            </button>
            <button className="queue-item-v2__header__actions__btn">
              <Popover
                trigger="click"
                boundary="window"
                placement="right"
                multiple={true}
                interactive={true}
                content={renderPopover(phoneNumber, contactName)}
              >
                <InfoCircle />
              </Popover>
            </button>
            {/* <button className="queue-item-v2__header__actions__btn">
              <Popover
                trigger="click"
                boundary="window"
                placement="right"
                multiple={true}
                interactive={true}
                content={renderMoreOptions(
                  contactId,
                  standbyId,
                  cdrId,
                  idAtendimento,
                  mediaId
                )}
              >
                <ActionIcon />
              </Popover>
            </button> */}
          </div>
          {!!unreadMessages && (
            <span className="queue-item-v2__header__actions-conatiner__unreade-messages">
              {unreadMessages}
            </span>
          )}
        </div>
      </div>
      <div className="queue-item-v2__content">
        {isExpanded && (
          <div className="queue-item-v2__content__phone-container">
            <Call />
            <Tooltippy content={phoneNumber} placement="top">
              <span>{phoneNumber}</span>
            </Tooltippy>
          </div>
        )}
        {isExpanded && (
          <div className="queue-item-v2__content__more-info-container">
            <Calendar />
            <span>{dateTime}</span>
          </div>
        )}
        <div className="queue-item-v2__content__timer-container">
          <Timer />
          <TimeCounterMinute
            horario={duracao < 0 ? 0 : parseInt(duracao)}
            day={dias}
            key={standbyId}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(QueueItemV2);
